var jsonApiMap = {};


// WEBPACK FOOTER //
// ../../../../../root/api-docs/assets/js/api-diff-tool/api-diff-tool-json-map.js